import axiosInstance from "./AxiosInstance";

const API_URL = "projectcodes"; // Adjust base URL as per your Express route

const ProjectCodesServices = {
  list: () => axiosInstance.get(`${API_URL}/`),
  getAdd: () => axiosInstance.get(`${API_URL}/add`),
  add: (data) => axiosInstance.post(`${API_URL}/add`, data),
  edit: (id) => axiosInstance.get(`${API_URL}/edit/${id}`),
  update: (data) => axiosInstance.post(`${API_URL}/update`, data),
  view: (id) => axiosInstance.get(`${API_URL}/view/${id}`),
  delete: (data) => axiosInstance.post(`${API_URL}/delete`, data),
  getProjectCode: (id) =>
    axiosInstance.post(`${API_URL}/getProjectCode`, { id: id }),
  importExcel: async (data) => {
    try {
      const response = await axiosInstance.post(
        `${API_URL}/import-excel`,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error import-excel project code", error);
      throw error;
    }
  },
};

export default ProjectCodesServices;
